import 'hammerjs';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey("CompanyName=Motherson Technology Service Ltd.,LicensedApplication=CAMS,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-035393,SupportServicesEnd=30_November_2023_[v2]_MTcwMTMwMjQwMDAwMA==052f2f4948b9b8fe20195a7200f7e027");

if (environment.production) {
  window.console.log = function () { };
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
